<div class="new-open-chart">
    <div class="card-custom p-4">
        <h2 class="chart-title">Báo cáo mở mới theo chi nhánh</h2>
        <div class="chart-container">
            <div class="card-item-custom" *ngFor="let chartOptions of chartOptionsList">
                <h3 class="chart-item-title">{{ chartOptions?.title }}</h3>
                <div *ngIf="loading" class="loading-container">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                <apx-chart *ngIf="!loading" [series]="chartOptions?.option?.series" [chart]="chartOptions?.option?.chart"
                    [plotOptions]="chartOptions?.option?.plotOptions" [dataLabels]="chartOptions?.option?.dataLabels"
                    [stroke]="chartOptions?.option?.stroke" [xaxis]="chartOptions?.option?.xaxis" [yaxis]="chartOptions?.option?.yaxis"
                    [fill]="chartOptions?.option?.fill" [annotations]="chartOptions?.option?.annotations"
                    [tooltip]="chartOptions?.option?.tooltip" [legend]="chartOptions?.option?.legend" [grid]="chartOptions?.option?.grid"
                    [markers]="chartOptions?.option?.markers">
                </apx-chart>
            </div>
        </div>
    </div>
</div>